import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinpuneairport() {



const cardData =
  {
    keyword: 'Corporate Cab Service in Pune Airport',
    heading: 'Sanavi Travels: Corporate Cab Service in Pune Airport',
    headingDescription: 'Sanavi Travels offers highly professional, punctual, and premium Corporate Cab Service in Pune Airport, specially designed for companies, executives, business travelers, MNCs, startups, and corporate teams that require seamless airport transportation. Corporate airport travel demands accuracy in timing, comfort, safety, and discretion, and our airport corporate cab services in Pune are structured to meet these exact requirements. Whether it is early morning airport pickups, late-night drops, VIP executive transfers, employee airport movement, or corporate guest transportation, Sanavi Travels ensures smooth coordination and zero-delay operations. Our fleet includes AC and Non-AC sedans, SUVs, and premium cars, all well-maintained and driven by trained chauffeurs who understand corporate etiquette, flight monitoring, luggage handling, and professional conduct. With real-time flight tracking, buffer-time planning, clean vehicles, transparent billing, GST invoices, and 24/7 support, corporate cab service at Pune Airport becomes stress-free and reliable. We serve all major business hubs, IT parks, MIDC areas, hotels, offices, and residential locations across Pune. Choosing Sanavi Travels for corporate airport cab services in Pune ensures time efficiency, comfort, safety, brand professionalism, and complete peace of mind for every corporate traveler.',

    top: 'Corporate Airport Travel Solutions in Pune',


"topPlaces": [
  {
    "title": "Corporate Airport Pickup Services",
    "description": "Corporate airport pickup services in Pune are essential for executives, employees, and business guests arriving on tight schedules. Sanavi Travels ensures on-time pickups with real-time flight tracking, trained chauffeurs waiting at arrival points, and smooth luggage assistance. This service reduces waiting time, avoids coordination issues, and ensures corporate travelers reach offices, hotels, or meeting venues comfortably and on schedule."
  },
  {
    "title": "Corporate Airport Drop Services",
    "description": "Corporate airport drop services in Pune focus on punctual departures and stress-free travel. Our drivers plan routes with traffic analysis, buffer time, and airport entry coordination to ensure timely arrivals. This service is ideal for executives, corporate teams, and VIPs who cannot afford flight delays."
  },
  {
    "title": "VIP Corporate Airport Transfers",
    "description": "VIP corporate airport transfers are designed for senior executives, directors, international clients, and special guests. Premium sedans and SUVs with professional chauffeurs provide a refined travel experience, privacy, and comfort, reflecting a strong corporate image."
  },
  {
    "title": "Employee Airport Transportation",
    "description": "Employee airport transportation is widely used for official travel, onboarding visits, training programs, and project deployments. Organized cab services ensure employees travel safely, on time, and without logistical stress."
  },
  {
    "title": "Corporate Guest Airport Transfers",
    "description": "Corporate guest airport transfers help companies manage transportation for clients, partners, and delegates. Reliable pickups and drops create a positive first impression and ensure smooth guest coordination."
  },
  {
    "title": "Airport Transfers for Corporate Meetings",
    "description": "Airport transfers for corporate meetings ensure executives and teams reach meeting locations directly from the airport without delays, helping organizations maintain productivity and schedule discipline."
  },
  {
    "title": "Airport Travel for Conferences and Events",
    "description": "Corporate events and conferences require coordinated airport transportation for multiple attendees. Sanavi Travels manages structured airport pickups and drops for groups, ensuring smooth event logistics."
  },
  {
    "title": "Outstation Corporate Airport Travel",
    "description": "For executives traveling from Pune Airport to nearby cities or industrial zones, corporate airport cab services offer comfortable and safe long-distance travel with professional handling."
  },
  {
    "title": "Late Night and Early Morning Airport Travel",
    "description": "Corporate travel often involves odd-hour flights. Our 24/7 airport cab services ensure safe, reliable, and punctual transportation regardless of flight timing."
  },
  {
    "title": "Hotel and Office Transfers from Airport",
    "description": "We provide seamless airport-to-hotel and airport-to-office transfers for corporate travelers, ensuring smooth transitions between travel and business engagements."
  }
]
,



"services": [
{
"name": "Corporate Cab Service in Pune Airport",
"description": "Corporate Cab Service in Pune Airport by Sanavi Travels delivers reliable, punctual, and professional airport transportation for corporate travelers. Designed for executives, employees, and business guests, this service ensures on-time pickups and drops, comfortable travel, and smooth coordination. With trained chauffeurs, clean vehicles, real-time flight tracking, and transparent billing, corporate airport travel becomes efficient and stress-free."
},
{
"name": "Airport Corporate Cab Pune",
"description": "Airport Corporate Cab Pune offers structured airport transportation solutions for companies, ensuring smooth movement of executives and employees between Pune Airport and business locations."
},
{
"name": "AC Airport Cab for Corporate Pune",
"description": "AC Airport Cab for Corporate Pune provides a comfortable and relaxed travel experience, ideal for long flights and business travelers requiring premium comfort."
},
{
"name": "Non AC Airport Cab Corporate Pune",
"description": "Non AC Airport Cab Corporate Pune offers economical airport transportation while maintaining safety, punctuality, and professional service standards."
},
{
"name": "Sedan Airport Cab Corporate Pune",
"description": "Sedan Airport Cab Corporate Pune is suitable for executives and solo travelers who require efficient, comfortable, and professional airport transfers."
},
{
"name": "SUV Airport Cab Corporate Pune",
"description": "SUV Airport Cab Corporate Pune supports group travel, VIP movement, and luggage-heavy trips with enhanced comfort and space."
},
{
"name": "Airport Pickup for Corporate Pune",
"description": "Airport Pickup for Corporate Pune ensures timely arrivals with flight monitoring, driver coordination, and hassle-free luggage handling."
},
{
"name": "Airport Drop for Corporate Pune",
"description": "Airport Drop for Corporate Pune focuses on punctual departures with route planning and buffer time management."
},
{
"name": "Affordable Airport Corporate Cab Pune",
"description": "Affordable Airport Corporate Cab Pune provides cost-effective corporate airport transport with transparent pricing and no hidden charges."
},
{
"name": "Best Corporate Airport Cab Service Pune",
"description": "Best Corporate Airport Cab Service Pune is trusted for reliability, professional chauffeurs, clean vehicles, and consistent service quality."
},
{
"name": "Corporate Airport Cab with Driver Pune",
"description": "Corporate Airport Cab with Driver Pune includes experienced chauffeurs trained in corporate etiquette, safety, and punctuality."
},
{
"name": "Airport Corporate Cab for VIP Travel Pune",
"description": "Airport Corporate Cab for VIP Travel Pune delivers premium vehicles and professional service for senior executives and special guests."
},
{
"name": "Airport Corporate Cab for Employee Pickup Pune",
"description": "Airport Corporate Cab for Employee Pickup Pune supports organized employee travel for official visits, training, and deployments."
},
{
"name": "Airport Corporate Cab for Office Travel Pune",
"description": "Airport Corporate Cab for Office Travel Pune ensures smooth movement from airport to office locations without delays."
},
{
"name": "Airport Corporate Cab for Meetings Pune",
"description": "Airport Corporate Cab for Meetings Pune allows executives to travel directly from airport to meeting venues efficiently."
}
],
"tableData": [
["Corporate Airport Cab Pune", "Airport Pickup Corporate Pune"],
["Airport Drop Corporate Pune", "VIP Airport Cab Pune"],
["Employee Airport Cab Pune", "Corporate Meeting Airport Cab"],
["Sedan Airport Cab Pune", "SUV Airport Cab Pune"],
["Affordable Airport Cab Pune", "Best Airport Corporate Cab Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Corporate Airport Cab Expertise",
    "WhyChoosedescription": "Sanavi Travels specializes in corporate airport transportation with structured processes and professional execution."
  },
  {
    "WhyChooseheading": "Punctual and Reliable Service",
    "WhyChoosedescription": "Flight tracking and route planning ensure on-time pickups and drops for every corporate traveler."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Drivers are trained in corporate etiquette, airport protocols, and safe driving practices."
  },
  {
    "WhyChooseheading": "Wide Fleet Options",
    "WhyChoosedescription": "Choose from sedans, SUVs, AC, Non-AC, and premium vehicles based on corporate requirements."
  },
  {
    "WhyChooseheading": "Transparent Billing",
    "WhyChoosedescription": "Clear pricing, GST invoices, and no hidden charges simplify corporate expense management."
  },
  {
    "WhyChooseheading": "24/7 Airport Operations",
    "WhyChoosedescription": "Round-the-clock availability ensures support for early morning and late-night flights."
  },
  {
    "WhyChooseheading": "Comfort and Safety",
    "WhyChoosedescription": "Clean, well-maintained vehicles ensure a safe and comfortable airport travel experience."
  },
  {
    "WhyChooseheading": "Trusted Corporate Partner",
    "WhyChoosedescription": "Sanavi Travels is trusted by businesses for consistent, high-quality corporate airport cab services."
  }
]

}

const faqData = [
  {
    question: 'Do you provide corporate cab services at Pune Airport?',
    answer: 'Yes, Sanavi Travels offers dedicated corporate cab services for Pune Airport pickups and drops.'
  },
  {
    question: 'Are airport pickups monitored with flight tracking?',
    answer: 'Yes, we track flights in real time to ensure timely pickups.'
  },
  {
    question: 'Do you offer AC and premium airport cabs?',
    answer: 'Yes, AC sedans, SUVs, and premium vehicles are available for corporate airport travel.'
  },
  {
    question: 'Are drivers trained for corporate travel?',
    answer: 'Yes, all chauffeurs are professionally trained and background verified.'
  },
  {
    question: 'Is airport cab service available 24/7?',
    answer: 'Yes, our corporate airport cab services operate round the clock.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Kulkarni',
    feedback: 'Excellent corporate airport cab service. Very punctual and professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Deshpande',
    feedback: 'We regularly use Sanavi Travels for airport transfers. Always reliable and comfortable.',
    rating: 5
  }
];




























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











// const jsonData = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Corporate Cab Service in Pune Airport - Sanavi Travels",
//   "description": "Sanavi Travels offers corporate cab services at Pune Airport for airport pickups, drops, VIP travel, employee transport, office travel, and meetings. AC and Non-AC sedans and SUVs are available with professional drivers at affordable rates.",
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.7",
//     "ratingCount": "10000+"
//   }
// };

const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id":
    "https://www.sanavitravels.com/corporate-cab-service-in-pune-airport#service",

  "name": "Corporate Cab Service in Pune Airport",

  "serviceType": "Corporate Airport Cab Service",

  "description":
    "Sanavi Travels provides corporate cab service at Pune Airport for employee transportation, business travel, client pickup and drop, corporate meetings, airport transfers and business trips with professional drivers.",

  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://www.sanavitravels.com/#business",
    "name": "Sanavi Travels",
    "url": "https://www.sanavitravels.com/",
    "telephone": "+91-7387507373"
  },

  "areaServed": {
    "@type": "Airport",
    "name": "Pune Airport",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },

  "url":
    "https://www.sanavitravels.com/corporate-cab-service-in-pune-airport"
};





  return (
    <div>


<Helmet>
  <title>
    Corporate Cab Service in Pune Airport | Airport Transfer | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book corporate cab service at Pune Airport with Sanavi Travels for employee transfers, business travel, client pickup and drop, corporate meetings and airport transportation with professional drivers."
  />

  <meta
    name="keywords"
    content="Corporate Cab Service in Pune Airport, Corporate Airport Cab Pune, Pune Airport Corporate Cab, Corporate Taxi Pune Airport, Airport Cab for Corporate Pune, Business Airport Transfer Pune, Employee Airport Transfer Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/corporate-cab-service-in-pune-airport"
  />

  {/* Open Graph */}
  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:title"
    content="Corporate Cab Service in Pune Airport | Sanavi Travels"
  />

  <meta
    property="og:description"
    content="Corporate airport cab service in Pune for employee transfers, business travel, client pickup and drop and corporate airport transportation."
  />

  <meta
    property="og:url"
    content="https://www.sanavitravels.com/corporate-cab-service-in-pune-airport"
  />

  <meta
    property="og:image"
    content="https://www.sanavitravels.com/images/corporate-cab-service-pune-airport.jpg"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

{/* <Helmet>
  <title>
    Call : +91 7387507373 | Corporate Cab Service in Pune Airport | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book corporate cab service at Pune Airport with Sanavi Travels. AC & Non-AC sedans and SUVs for pickups, drops, VIP travel, employee transport, office travel, and meetings with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet> */}

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/corporate-cab-service-pune-airport.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinpuneairport;